import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Label, Card, CardBody, Input, Button, Spinner, FormFeedback, Form } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import PreviewCardHeader from '../../../Components/Common/PreviewCardHeader';
import { addNewOrganization, resetOrganizationFlag } from '../../../store/actions';
import * as Yup from "yup";
import { useFormik } from "formik";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import MsgToast from "../../../Components/Common/MsgToast";

const OrganizationCreate = () => {
    document.title = "Create Organization | Defendit - Admin Panel";
    const dispatch = useDispatch();
    const [isCreating, setIsCreating] = useState(false);
    const { isOrganizationAdd, isOrganizationAddFail, error, success } = useSelector(state => ({
        isOrganizationAdd: state.Organisations.isOrganizationAdd,
        isOrganizationAddFail: state.Organisations.isOrganizationAddFail,
        error: state.Organisations.error,
        success: state.Organisations.success,
    }));

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            name: '',
            description: ""
        },
        validationSchema: Yup.object({
            name: Yup.string().required("Please Enter Organization title"),
            description: Yup.string().required("Please Enter Description")
        }),
        onSubmit: (values) => {
            setIsCreating(true)
            const data = {
                title: values.name,
                description: values.description
            }
            dispatch(addNewOrganization(data))
        },
    });

    useEffect(() => {
        if (isOrganizationAdd || isOrganizationAddFail) {
            setIsCreating(false)
            validation.resetForm();
            setTimeout(() => {
                dispatch(resetOrganizationFlag())
            }, 3000);
        }
    }, [dispatch, isOrganizationAdd, isOrganizationAddFail, validation]);

    return (
        <>
            <div className="page-content">
                <Container fluid={true}>
                    <BreadCrumb title="Create Organization" pageTitle="Organizations" pageUrl="/organization" />
                    <Row>
                        <Form onSubmit={(e) => {
                            e.preventDefault();
                            validation.handleSubmit();
                            return false;
                        }}>
                            <Col lg={12}>
                                <Card>
                                    <PreviewCardHeader title="Create Organization" />

                                    <CardBody className="card-body">

                                        <div className="live-preview">
                                            <Row className="gy-4">
                                                <Col xxl={3} md={6}>
                                                    <div>
                                                        <Label htmlFor="placeholderInput" className="form-label">Organization Title</Label>
                                                        <Input
                                                            type="text"
                                                            id='placeholderInput'
                                                            className="form-control"
                                                            placeholder="Organization title"
                                                            name='name'
                                                            value={validation.values.name || ""}
                                                            onChange={validation.handleChange}
                                                            onBlur={validation.handleBlur}
                                                            validate={{
                                                                required: { value: true },
                                                            }}
                                                            invalid={
                                                                validation.touched.name && validation.errors.name ? true : false
                                                            }
                                                        />
                                                        {validation.touched.name && validation.errors.name ? (
                                                            <FormFeedback type="invalid">{validation.errors.name}</FormFeedback>
                                                        ) : null}
                                                    </div>
                                                </Col>

                                                <Col xxl={12} md={12}>
                                                    <div>
                                                        <Label
                                                            htmlFor="placeholderInput"
                                                            className="form-label"
                                                        >
                                                            Description*
                                                        </Label>
                                                        <Input
                                                            type="textarea"
                                                            id="placeholderInput"
                                                            rows="3"
                                                            className="form-control"
                                                            placeholder="Enter description"
                                                            name="description"
                                                            value={validation.values.description || ""}
                                                            onChange={validation.handleChange}
                                                            onBlur={validation.handleBlur}
                                                            validate={{
                                                                required: { value: true },
                                                            }}
                                                            invalid={
                                                                validation.touched.description &&
                                                                    validation.errors.description
                                                                    ? true
                                                                    : false
                                                            }
                                                        />
                                                        {validation.touched.description &&
                                                            validation.errors.description ? (
                                                            <FormFeedback type="invalid">
                                                                {validation.errors.description}
                                                            </FormFeedback>
                                                        ) : null}
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </CardBody>
                                </Card>

                                <div className="text-end mb-4">
                                    <Link to="/organization" className="btn btn-danger w-sm me-1">Cancel</Link>
                                    <Button color="success" className="btn-load" disabled={isCreating} type="submit">
                                        <span className="d-flex align-items-center">
                                            {isCreating && <Spinner size="sm" className="flex-shrink-0 me-2"> Create </Spinner>}
                                            <span className="flex-grow-1">
                                                Create
                                            </span>
                                        </span>
                                    </Button>
                                </div>
                            </Col>
                        </Form>
                    </Row>
                    {isOrganizationAdd ? <MsgToast msg={success} color="success" icon="ri-checkbox-circle-line" /> : null}
                    {isOrganizationAddFail ? <MsgToast msg={error} color="danger" icon="ri-error-warning-line" /> : null}
                    <ToastContainer limit={1} closeButton={false} />
                </Container>
            </div>
        </>
    );
}

export default OrganizationCreate;